(function() {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .factory('sessionInjector', sessionInjector);

    sessionInjector.$inject = ['$log', '$templateCache', 'UserSvc'];

    /**
     * Adds the stored session ID to each HTTP request as the Authorization header.
     * @memberOf ihh-utilities
     * @name sessionInjector
     */
    function sessionInjector($log, $templateCache, UserSvc) {
        var sessionInjector = {
            request: function(config) {
                // we should add our html to the templateCache instead of checking for URLS ending in '.html'
                if (angular.isDefined($templateCache.get(config.url)) || config.url.indexOf('.html', config.url.length - '.html'.length) !== -1) {
                    $log.debug('Servicing template: ' + config.url);
                    return config;
                }
                else {
                    $log.debug('Requesting: ' + config.url);
                    var session = UserSvc.get().session;
                    if (session) {
                        if (session.id) {
                            config.headers.Authorization = session.id;
                        }

                        return config;
                    }
                    else {
                        $log.debug('Servicing without session: ' + config.url);
                        return config;
                    }
                }
            }
        };

        return sessionInjector;
    }
})();